<template>
  <div class="popup_wrap country_guide_pop" style="width:560px;">
    <button
      type="button"
      class="layer_close"
      @click="closePop"
    >
      close
    </button>
    <div class="flag_deco" aria-hidden="true">
      <country-flag
        v-for="(deco, i) in boostedFlagDecos"
        :key="i"
        :country="parentInfo.country"
        class="flag_item"
        :style="deco"
      />
    </div>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t(parentInfo.msg.title, { country: countryName }) }}</h1>
      <i18n :path="parentInfo.msg.cont" tag="p" class="guide_desc pre_line">
        <template #country>{{ countryName }}</template>
        <template #cnUrl>
          <a :href="parentInfo.url">{{ displayUrl }}</a>
        </template>
        <template #comUrl>
          <a :href="INTL_SITE_URL">{{ displayIntlUrl }}</a>
        </template>
        <template #important>
          <b>{{ noticeLabel }}</b>
        </template>
      </i18n>
      <div class="btn_area text_center">
        <a
          class="button blue lg"
          href="#"
          @click.prevent="goCountrySite()"
        >{{ $t(parentInfo.msg.btn, { country: countryName }) }}</a>
      </div>
      <p class="no_show_check">
        <input
          type="checkbox"
          id="country_guide_no_show"
          v-model="noShow"
        />
        <label for="country_guide_no_show">{{ $t('msg.MAIN010G030.044', { days: parentInfo.noShowDays }) }}</label>
      </p>
    </div>
  </div>
</template>

<script>
import CountryFlag from '@/components/common/CountryFlag'

// 흰 바탕 위주 국기는 기본 투명도(중국 국기 기준)로는 안 보이므로 배율 보정
const FLAG_OPACITY_BOOST = { JP: 2.5 }

export default {
  name: 'CountrySiteGuidePop',
  components: {
    CountryFlag
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          country: '',
          url: '',
          noShowDays: 0,
          msg: {
            name: '',
            title: '',
            cont: '',
            noticeLabel: '',
            btn: ''
          }
        }
      }
    }
  },
  computed: {
    // 언어별 국가 표시명
    countryName () {
      return this.$t(this.parentInfo.msg.name)
    },
    // 본문 내 링크 표시용 URL (프로토콜 제거)
    displayUrl () {
      return (this.parentInfo.url || '').replace(/^https?:\/\//, '')
    },
    // 국제 사이트 링크 표시용 URL (프로토콜 제거)
    displayIntlUrl () {
      return this.INTL_SITE_URL.replace(/^https?:\/\//, '')
    },
    // 중요 안내 라벨 (없는 국가는 빈 문자열)
    noticeLabel () {
      return this.parentInfo.msg.noticeLabel ? this.$t(this.parentInfo.msg.noticeLabel) : ''
    },
    // 국가별 투명도 보정이 적용된 국기 장식 배열
    boostedFlagDecos () {
      const boost = FLAG_OPACITY_BOOST[this.parentInfo.country] || 1
      return this.flagDecos.map(d => ({ ...d, opacity: Math.min(d.opacity * boost, 0.3) }))
    }
  },
  data: function () {
    return {
      noShow: false,
      // 본문에서 참조하는 기존 국제 사이트
      INTL_SITE_URL: 'https://www.ekmtc.com',
      // 배경 국기 장식: 모서리·좌우 가장자리에만 배치 (음수 오프셋으로 걸쳐서 본문 영역은 비움)
      flagDecos: [
        { top: '-25px', left: '-40px', width: '130px', transform: 'rotate(-15deg)', opacity: 0.07 },
        { top: '-20px', right: '-45px', width: '110px', transform: 'rotate(12deg)', opacity: 0.06 },
        { top: '30%', left: '-60px', width: '150px', transform: 'rotate(8deg)', opacity: 0.07 },
        { top: '55%', right: '-65px', width: '160px', transform: 'rotate(-10deg)', opacity: 0.07 },
        { bottom: '-30px', left: '-45px', width: '140px', transform: 'rotate(14deg)', opacity: 0.08 },
        { bottom: '-40px', right: '-50px', width: '190px', transform: 'rotate(-12deg)', opacity: 0.09 },
        // 본문 중앙 겹침 확인용 (7·8번)
        { top: '28%', left: '30%', width: '230px', transform: 'rotate(-8deg)', opacity: 0.06 },
        { top: '58%', left: '22%', width: '180px', transform: 'rotate(10deg)', opacity: 0.05 }
      ]
    }
  },
  methods: {
    closePop () {
      this.$emit('close', { noShow: this.noShow })
    },
    goCountrySite () {
      window.location.href = this.parentInfo.url
    }
  }
}
</script>

<style scoped>
/* 기본 overflow:auto 는 팝업 밖으로 나간 국기 장식 때문에 스크롤이 생기므로 잘라냄 */
.country_guide_pop {
  overflow: hidden;
}
.country_guide_pop::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #de2910 0%, #de2910 60%, #ffde00 100%);
}
.flag_deco {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
.flag_deco .flag_item {
  position: absolute;
}
.country_guide_pop .guide_desc {
  margin-top: 25px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 1.7;
  text-align: left;
}
/* i18n 문자열의 \n 을 줄바꿈으로 렌더링 */
.pre_line {
  white-space: pre-line;
}
/* 본문 내 링크 (사이트 버튼 블루 톤) */
.country_guide_pop .guide_desc a {
  color: #0641b8;
  text-decoration: underline;
}
/* 중요 안내 라벨 강조 */
.country_guide_pop .guide_desc b {
  font-weight: 700;
  color: #de2910;
}
.country_guide_pop .btn_area {
  margin: 25px 0 20px;
}
.country_guide_pop .no_show_check {
  text-align: left;
}
</style>
